import GetCookie from '../GetCookie'
import Cookie from './Cookie'
import axios from 'axios'

// ==========================================================================================
// 定数
// ==========================================================================================
const TARGET_COOKIE = '_mkto_trk'
const SESSION_CHECKED_COOKIE = '_mkto_session_checked'
const API_KEY = 'hUkf4dATuqNa5n'
const MARKETO_COOKIE_DOMAIN_LIST = ['.shimadzu.com', '.shimadzu.co.jp']
const HOST = location.host
const ApiResponseStatus = {
  /** 正常 */
  Success: 200000
}

// ==========================================================================================
// グローバル変数
// ==========================================================================================

let trackingCookieValue = ''
let sessionCheckedCookieValue = ''
let cookieInfo = {}
let deleteMarketoDomain: string | undefined

// ==========================================================================================
// メインロジック
// ==========================================================================================
export async function callCookieDeleteCheck() {
  // Cookie関連クラス
  const cookieClass = new GetCookie()
  const cookie = new Cookie()
  let multiplexPreventionCookieList: string[]

  // Marketo_Cookieチェック
  trackingCookieValue = cookieClass.get(TARGET_COOKIE)
  if (trackingCookieValue === '') {
    // 値が取れない場合、指定したキーのcookieは存在しないため処理終了
    return
  }

  // 同セッションチェック不要Cookie存在チェック
  sessionCheckedCookieValue = cookieClass.get(SESSION_CHECKED_COOKIE)

  if (trackingCookieValue !== sessionCheckedCookieValue) {
    // リクエスト情報の作成
    createCookieInfo()

    // Cookie削除確認APIをコール
    const requestResult = await executeApi(
      drupalSettings.vueComponent.idShimadzu.domain +
        'member/api/cookie_delete_check',
      JSON.stringify(cookieInfo)
    )
    if (
      requestResult.status &&
      requestResult.data.status_code === ApiResponseStatus.Success
    ) {
      if (requestResult.data.delete_marketo_cookie_flg) {
        // MarketoトラッキングCookie 削除対象ドメイン取得
        for (const domain of MARKETO_COOKIE_DOMAIN_LIST) {
          if (HOST.endsWith(domain)) {
            deleteMarketoDomain = domain
          }
        }

        // MarketoトラッキングCookie削除
        cookie.setCookie(TARGET_COOKIE, '', -1, '/', deleteMarketoDomain)

        // Cookie保存多重送信防止Cookie削除
        multiplexPreventionCookieList = cookieClass.match(
          /^_mch-shimadzu.(co.jp|com)/
        )
        multiplexPreventionCookieList.forEach((key) => {
          cookie.setCookie(key, '', -1, '/')
        })
      }

      // 同セッションチェック不要Cookie作成
      cookie.setCookie(
        SESSION_CHECKED_COOKIE,
        trackingCookieValue.replace('&amp;', '&'),
        null,
        '/'
      )
    }
  }
}

// ==========================================================================================
// 実行関数
// ==========================================================================================

/**
 * リスエスト用オブジェクトの作成関数
 */
function createCookieInfo() {
  cookieInfo = {
    apiKey: API_KEY,
    cookies: trackingCookieValue.replace('&amp;', '&')
  }
}

// JavaAPI実行の共通処理
export function executeApi(url: string, jsonData: string) {
  return axios.post(url, jsonData)
}
